import { type StateCreator } from "zustand";

/**
 * Sidebar "view by" filter. Stores the active view as a plain string so
 * the slice stays decoupled from the per-platform NavDomain registry
 * (which lives in the consuming app). Consumers validate the string on
 * read and fall back to "all" if the persisted value is no longer a
 * known view (e.g. a domain was removed).
 */
export interface ViewState {
  activeView: string;
}

export interface ViewActions {
  setActiveView: (view: string) => void;
}

export type ViewSlice = ViewState & ViewActions;

export const createViewSlice: StateCreator<ViewSlice, [], [], ViewSlice> = (set) => ({
  activeView: "all",
  setActiveView: (view) => set({ activeView: view }),
});
